<script setup lang="ts">
import { inject, ref } from 'vue'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import { addUser } from '~/layers/cms/app/composables/cms'

const toast = usePrimeToast()
const dialogRef = inject<DialogRef>('dialogRef')
const email = ref<string>('')
const password = ref<string>('')

interface DialogRef {
  value: {
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const addNewUser = async () => {
  if (!dialogRef || !password.value || !email.value) return
  const response = await addUser(password.value, email.value)
  if (!response.status_ok) {
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Nie udało się dodać usera',
      life: 3000
    })
  } else {
    toast.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Poprawnie dodano usera',
      life: 3000
    })
    closeDialog()
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <label>
      Wpisz email:
      <InputText
        v-model="email"
        required
        type="email"
      />
    </label>
    <label>
      Wpisz hasło:
      <InputText
        v-model="password"
        required
        type="password"
      />
    </label>
    <Button
      type="button"
      label="Zapisz"
      severity="primary"
      @click="addNewUser"
    />
  </div>
</template>
